export default "__VITE_ASSET__DYofi65X__"